<svg 
  class="zaver-icon zaver-icon--{{ name }}" 
  [attr.viewBox]="viewBox" 
  [attr.height]="size"
  [attr.data-theme]="isVariableIcon ? override : null"
  >
    <use 
      [attr.href]="iconName"
    />
</svg>
